import { valibotResolver } from '@hookform/resolvers/valibot';
import { boolean, custom, nonEmpty, number, object, pipe, string, union } from 'valibot';

import { DEFAULT_CURRENCY } from '@constants/currency';

import type { ICurrency } from '@model/currency';
import type { ITemplate } from '@model/templateItem';

import type { ITemplateCurrenciesList } from '@pages/MultiplicationFactors/model/templateCurrenciesList';

export interface IFormCostSavingTemplate {
  name: string;
  multiplication_factor: number;
  currency: ICurrency;
  recalculate_cost_saving: boolean;
}

export const COST_SAVING_TEMPLATE_FIELDS = {
  NAME: 'name',
  MULTIPLICATION_FACTOR: 'multiplication_factor',
  CURRENCY: 'currency',
  RECALCULATE_COST_SAVING: 'recalculate_cost_saving',
};

export const schemaCostSavingTemplate = valibotResolver(
  object({
    [COST_SAVING_TEMPLATE_FIELDS.NAME]: pipe(string(), nonEmpty('This field is required.')),
    [COST_SAVING_TEMPLATE_FIELDS.MULTIPLICATION_FACTOR]: pipe(
      union([string(), number()]),
      custom((input) => /^[^eE.+-]+$/.test(String(input)), 'Value should be integer'),
    ),
    [COST_SAVING_TEMPLATE_FIELDS.CURRENCY]: object({
      code: string(),
      name: string(),
      symbol: string(),
    }),
    [COST_SAVING_TEMPLATE_FIELDS.RECALCULATE_COST_SAVING]: boolean(),
  }),
);

export const costSavingTemplateDefaultValue = (
  currencies: ITemplateCurrenciesList[],
  currentTemplate?: ITemplate,
) => ({
  [COST_SAVING_TEMPLATE_FIELDS.NAME]: currentTemplate?.name || '',
  [COST_SAVING_TEMPLATE_FIELDS.MULTIPLICATION_FACTOR]: currentTemplate?.multiplication_factor || '',
  [COST_SAVING_TEMPLATE_FIELDS.CURRENCY]:
    currentTemplate?.currency || (currencies.length ? currencies[0] : DEFAULT_CURRENCY),
  [COST_SAVING_TEMPLATE_FIELDS.RECALCULATE_COST_SAVING]: false,
});
